import { useRef } from 'react';
var counter = 0;
export function guid(prefix) {
  if (prefix === void 0) {
    prefix = '';
  }
  counter++;
  return "" + prefix + counter;
}
export default function useGuid(prefix) {
  if (prefix === void 0) {
    prefix = '';
  }
  var id = useRef(guid(prefix));
  return id.current;
}